$(document).ready(function () {
  // Free gift with link
  function freeEmailGift() {
    var currentVariant = 32638154539089;
    jQuery.getJSON("/cart.js", function (cart) {
      var gift_in_cart = 0;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].id == currentVariant) {
          gift_in_cart += cart.items[i].quantity;
        }
      }
      console.log(gift_in_cart, "Gift In Cart");

      // Setting up the gift
      if (gift_in_cart < 1) {
        data = {
          id: currentVariant,
          quantity: 1,
        };

        jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          dataType: "json",
          success: function () {
            console.log(data);
            createCart();
            setTimeout(function () {
              $(".Slide_cart_whole").css("right", "0px");
              $(".Slide_cart_overlay").show();
            }, 500);
          },
        });
      } else if (gift_in_cart > 1) {
        data = {
          id: currentVariant,
          quantity: 1,
        };

        jQuery.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: data,
          dataType: "json",
          success: function () {
            console.log(data);
            createCart();
            setTimeout(function () {
              $(".Slide_cart_whole").css("right", "0px");
              $(".Slide_cart_overlay").show();
            }, 500);
          },
        });
      }

      if (cart.total_price > 2500) {
        // console.log('Checkout available');
      } else {
        $(".Slide_cart_checkout_button__js").addClass("Disabled");
        $(".Checkout_button_reserve_message").text(
          "Your purchase must be $25 and over to get the Free Gift!"
        );
      }
    });
  }

  var location_url = window.location;
  location_url = String(location_url);
  if (location_url.indexOf("#FreeGiftFromEmailWz379") != -1) {
    freeEmailGift();
  }

  function makeTimer() {
    //		var endTime = new Date("29 April 2018 9:56:00 GMT+01:00");
    var endTime = new Date("21 November 2022 00:00:00 GMT+01:00");
    endTime = Date.parse(endTime) / 1000;

    var now = new Date();
    now = Date.parse(now) / 1000;

    var timeLeft = endTime - now;

    var days = Math.floor(timeLeft / 86400);
    var hours = Math.floor(timeLeft / 3600);
    var hours_to_calc = Math.floor((timeLeft - days * 86400) / 3600);
    var minutes = Math.floor(
      (timeLeft - days * 86400 - hours_to_calc * 3600) / 60
    );
    var seconds = Math.floor(
      timeLeft - days * 86400 - hours_to_calc * 3600 - minutes * 60
    );
    var passDays = "<div>Vote ends In: " + days + " days: </div>";
    var passHours = hours_to_calc + "<div> hours: </div>";
    var passMinutes = minutes + "<div> minutes</div>";

    if (hours_to_calc < "10") {
      hours_to_calc = "0" + hours_to_calc;
    }
    if (minutes < "10") {
      minutes = "0" + minutes;
    }
    if (seconds < "10") {
      seconds = "0" + seconds;
    }

    $(".Offer_hours").html(hours);
    $(".Offer_minutes").html(minutes);
    $(".Offer_seconds").html(seconds);
  }

  // setInterval(function() { makeTimer(); }, 1000);

  /*$('.offer_container_slick').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:"<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/1071/5272/files/Icon_ionic-ios-arrow-dropdown-1_2x_3b877f17-a1df-493b-8676-df64d126a664.png?v=1633589723'/></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/1071/5272/files/Icon_ionic-ios-arrow-dropdown_2x_286e5730-16a2-4f3e-a46c-bee8dd6fc17c.png?v=1633589723'/></button>"

    });*/
  setTimeout(function () {
    $(".product-grid-area ").css("opacity", "1");
  }, 100);

  $(".product_images_carousel_both").css("opacity", "1");
  $(".go_to_product").click(function () {
    $("html,body").animate(
      {
        scrollTop: $(".product-grid-area").offset().top,
      },
      "slow"
    );
  });

  $(".product_images_carousel").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: ".product_images_carousel__navigation",
  });
  $(".product_images_carousel__navigation").slick({
    infinite: true,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: ".product_images_carousel",
    responsive: [
      {
        breakpoint: 749,
        settings: {
          vertical: false,
        },
      },
    ],
  });

  $(".variant_button_selector").click(function () {
    var clicked_Variant_position = $(this).attr("variant_position");
    //     $('.product_images_carousel').slick('slickGoTo', clicked_Variant_position);
  });
  setTimeout(function () {
    $(".Homepage_banner_whole_container").addClass("loaded");
  }, 200);

  setTimeout(function () {
    $(".Homepage_banner_whole_container").addClass("loaded");
  }, 200);

  $(".Slide_cart_upsells_slider").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
  });

  $(".vip-reviews-section").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/1071/5272/files/Icon_ionic-ios-arrow-dropdown_1.png?v=1634023218'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/1071/5272/files/Icon_ionic-ios-arrow-dropdown-1.png?v=1634023218'/></button>",
    dots: true,
  });

  $(".customer-favor-carousel").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/1071/5272/files/Icon_ionic-ios-arrow-dropdown_1.png?v=1634023218'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/1071/5272/files/Icon_ionic-ios-arrow-dropdown-1.png?v=1634023218'/></button>",
  });

  $(".prod-slider-slick").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/1071/5272/files/Icon_ionic-ios-arrow-dropdown_1.png?v=1634023218'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/1071/5272/files/Icon_ionic-ios-arrow-dropdown-1.png?v=1634023218'/></button>",
  });

  $(".fyh-icons-carousel").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
  });

  $(".testimonial-slider-slick").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/1071/5272/files/Icon_ionic-ios-arrow-dropdown_1.png?v=1634023218'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/1071/5272/files/Icon_ionic-ios-arrow-dropdown-1.png?v=1634023218'/></button>",
  });

  $(".learn_page_image_carousel").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "60px",
    arrows: false,
  });

  $("#button_to_show_more_0").click(function () {
    $("#hidden_text_0").slideDown();
    $("#button_to_show_more_0").hide();
  });

  $("#button_to_show_less_0").click(function () {
    $("#hidden_text_0").slideUp();
    $("#button_to_show_more_0").show();
  });

  $("#button_to_show_more_1").click(function () {
    $("#hidden_text_1").slideDown();
    $("#button_to_show_more_1").hide();
  });

  $("#button_to_show_less_1").click(function () {
    $("#hidden_text_1").slideUp();
    $("#button_to_show_more_1").show();
  });
});

$(document).ready(function () {
  // Email free gift
  if (window.location.href.indexOf("#emailFreeGift") != -1) {
    var giftId = 32638154539089;
    var gift_in_cart = 0;
    jQuery.getJSON("/cart.js", function (cart) {
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].id == giftId) {
          gift_in_cart += cart.items[i].quantity;
        }
      }
      if (gift_in_cart == 0) {
        data = {
          id: giftId,
          quantity: 1,
        };

        jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          dataType: "json",
          success: function () {
            console.log(data);
            createCart();
            setTimeout(function () {
              $(".Slide_cart_whole").css("right", "0px");
              $(".Slide_cart_overlay").show();
            }, 500);
          },
        });
      } else {
        data = {
          id: giftId,
          quantity: 1,
        };

        jQuery.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: data,
          dataType: "json",
          success: function () {
            console.log(data);
            createCart();
            setTimeout(function () {
              $(".Slide_cart_whole").css("right", "0px");
              $(".Slide_cart_overlay").show();
            }, 500);
          },
        });
      }
      console.log(gift_in_cart, "Gift Id");
    });
  }

  // Email exclusive deal quantity adjustment
  if (window.location.href.indexOf("/the-wand-30-pack-silver") != -1) {
    setTimeout(function () {
      $(".js-qty__adjust--plus").trigger("click");
    }, 100);
  }
  // if (window.location.href.indexOf("/the-phoenix-bio-pod-refill-8-pack") != -1) {
  //   $('.js-qty__adjust--plus').trigger('click');
  // }
  // if (window.location.href.indexOf("/products/the-phoenix-bio-pod-refill") != -1) {
  //   $('.js-qty__adjust--plus').trigger('click');
  // }

  // For onetime

  if (
    window.location.href.indexOf(
      "/the-wand-subscription-sale#silver_30_one"
    ) !== -1
  ) {
    $(".wand-selector .wrapper_1 .input_num_3 input").trigger("click");
    $(".wand-selector .wrapper_2 .input_num_1 input").trigger("click");
  } else if (
    window.location.href.indexOf("/the-wand-subscription-sale#usa_30_one") !==
    -1
  ) {
    $(".wand-selector .wrapper_1 .input_num_3 input").trigger("click");
    $(".wand-selector .wrapper_2 .input_num_5 input").trigger("click");
  }

  // For subs
  else if (
    window.location.href.indexOf("the-wand-subscription-sale#silver_30_sub") !==
    -1
  ) {
    setTimeout(function () {
      $(".wand-selector .wrapper_1 .input_num_3 input").trigger("click");
      $(".wand-selector .wrapper_2 .input_num_1 input").trigger("click");
      $(".rc_label__autodeliver").trigger("click");
    }, 2000);
  } else if (
    window.location.href.indexOf("the-wand-subscription-sale#usa_30_sub") !== -1
  ) {
    setTimeout(function () {
      $(".rc_label__autodeliver").trigger("click");
      $(".wand-selector .wrapper_1 .input_num_3 input").trigger("click");
      $(".wand-selector .wrapper_2 .input_num_5 input").trigger("click");
    }, 2000);
  } else if (
    window.location.href.indexOf(
      "the-phoenix-bio-pod-refill-subscription-sale#sub"
    ) !== -1
  ) {
    setTimeout(function () {
      $(".rc_label__autodeliver").trigger("click");
    }, 2000);
  } else if (
    window.location.href.indexOf("the-phoenix-bio-pod-refill-8-pack#sub") !== -1
  ) {
    setTimeout(function () {
      $(".rc_label__autodeliver").trigger("click");
    }, 2000);
  } else {
    // Preselecting Variant on load
    var SelectedInput_wrapper1 =
      "." +
      $(".wrapper_1 input:checked").parent(".variant-input").attr("data_num");
    var SelectedInput_wrapper2 =
      "." +
      $(".wrapper_2 input:checked").parent(".variant-input").attr("data_num");
    $(".wrapper_1 " + SelectedInput_wrapper1 + " input").trigger("click");
    $(".wrapper_2 " + SelectedInput_wrapper2 + " input").trigger("click");
    console.log(SelectedInput_wrapper1, SelectedInput_wrapper2);
  }

  if (window.location.href.indexOf("bio-pod-refill#subscribe") !== -1) {
    setTimeout(function () {
      $(".Autodelivery_trigger__js").trigger("click");
    }, 500);
  }

  if (window.location.href.indexOf("/the-wand-1#30_usa") !== -1) {
    $(".wand-selector .wrapper_1 .input_num_3 input").trigger("click");
    $(".wand-selector .wrapper_2 .input_num_5 input").trigger("click");
  }

  if (window.location.href.indexOf("/the-wand-1#silverGold") !== -1) {
    $(".wand-selector .wrapper_2 .input_num_4 input").trigger("click");
  }

  if (
    window.location.href.indexOf("/the-wand-color-bundle#silver_red") !== -1
  ) {
    $(".wand-selector .wrapper_1 .input_num_2 input").trigger("click");
  }

  if (window.location.href.indexOf("the-phoenix-starter-kit-1#noir") !== -1) {
    $(".wand-selector .wrapper_1 .input_num_3 input").trigger("click");
  }

  if (window.location.href.indexOf("#silver_wand_30") !== -1) {
    $(".wand-selector .wrapper_1 .input_num_3 input").trigger("click");
  }
  // if (window.location.href.indexOf("#variety") !== -1) {
  //   $(".wand-selector .wrapper_1 .input_num_4 input").trigger("click");
  //   $(".wand-selector .wrapper_2 .input_num_6 input").trigger("click");
  // }

  if (window.location.href.indexOf("the-wand-1#pink") !== -1) {
    $(".wand-selector .wrapper_2 .input_num_2 input").trigger("click");
  }

  if (
    window.location.href.indexOf(
      "https://drinkpurewine.com/products/the-wand-1?utm_source=Klaviyo&utm_medium=Broadcast&utm_campaign=Campaign_name&triplesource=klaviyo&_kx=Ic2d_lAA3diA6-ocCMGQ9MbTWelpaeSzzwfCfGJTp3KD8zw4e0MmT0xB2LBMH"
    ) !== -1
  ) {
    $(".wand-selector .wrapper_1 .input_num_3 input").trigger("click");
    $(".wand-selector .wrapper_2 .input_num_5 input").trigger("click");
  }

  if (window.location.href.indexOf("/products/the-wand-1#3_pink") !== -1) {
    $(".wand-selector .wrapper_1 .input_num_2 input").trigger("click");
    $(".wand-selector .wrapper_2 .input_num_2 input").trigger("click");
  }
  // if (window.location.href.indexOf("#40variety") !== -1) {
  //   $(".wand-selector .wrapper_1 .input_num_4 input").trigger("click");
  //   $(".wand-selector .wrapper_2 .input_num_6 input").trigger("click");
  // }
  // if (window.location.href.indexOf("41993943449787") !== -1) {
  //   $(".wand-selector .wrapper_1 .input_num_4 input").trigger("click");
  //   $(".wand-selector .wrapper_2 .input_num_6 input").trigger("click");
  // }

  if (window.location.href.indexOf("#wand_8_pack_red") !== -1) {
    $(".wand-selector .wrapper_1 .input_num_1 input").trigger("click");
    $(".wand-selector .wrapper_2 .input_num_3 input").trigger("click");
  }

  if (window.location.href.indexOf("#wand_90_pack_silver") !== -1) {
    $(".wand-selector .wrapper_1 .input_num_5 input").trigger("click");
    $(".wand-selector .wrapper_2 .input_num_1 input").trigger("click");
  }

  if (window.location.href.indexOf("#phoenix_rose") !== -1) {
    $(".wand-selector .wrapper_1 .input_num_2 input").trigger("click");
  }

  // if (window.location.href.indexOf("/products/the-wand-1?variant=43588373643507") !== -1 ){
  //   window.location = 'https://drinkpurewine.com/#sale_offer';
  // }

  if (window.location.href.indexOf("#purifying_wine") !== -1) {
    setTimeout(function () {
      $("html, body").animate(
        {
          scrollTop: $(".Faqs_scrolled_to_js").offset().top - 150,
        },
        200
      );
    }, 1000);
  }

  if (window.location.href.indexOf("#wand_30_sub") !== -1) {
    setTimeout(function () {
      $(".Autodelivery_trigger__js").trigger("click");
    }, 500);
  }

  if (window.location.href.indexOf("#wand_90_sub") !== -1) {
    setTimeout(function () {
      $(".Autodelivery_trigger__js").trigger("click");
      $(".wand-selector .wrapper_1 .input_num_5 input").trigger("click");
    }, 500);
  }

  if (window.location.href.indexOf("#bio_sub") !== -1) {
    setTimeout(function () {
      $(".Autodelivery_trigger__js").trigger("click");
    }, 500);
  }

  // init controller
  var controller = new ScrollMagic.Controller();
  var controller_2 = new ScrollMagic.Controller();
  var controller_3 = new ScrollMagic.Controller();
  var controller_4 = new ScrollMagic.Controller();
  var controller_5 = new ScrollMagic.Controller();

  // create a scene
  new ScrollMagic.Scene({
    triggerElement: "#Product_section_slide_in_1",
    triggerHook: 0.7,
  })
    .setClassToggle("#Product_section_slide_in_1", "slide_in__from_right")
    .addTo(controller); // assign the scene to the controller

  new ScrollMagic.Scene({
    triggerElement: "#Product_section_2_slide_in",
    triggerHook: 0.7,
  })
    .setClassToggle("#Product_section_2_slide_in", "slide_in__from_left")
    .addTo(controller_2); // assign the scene to the controller

  new ScrollMagic.Scene({
    triggerElement: "#Product_section_3_slide_in",
    triggerHook: 0.7,
  })
    .setClassToggle("#Product_section_3_slide_in", "slide_in__from_right")
    .addTo(controller_3); // assign the scene to the controller

  new ScrollMagic.Scene({
    triggerElement: "#Product_section_4_slide_in",
    triggerHook: 0.7,
  })
    .setClassToggle("#Product_section_4_slide_in", "slide_in__from_left")
    .addTo(controller_4); // assign the scene to the controller

  new ScrollMagic.Scene({
    triggerElement: "#Product_section_bottom",
    triggerHook: 0.7,
  })
    .setClassToggle("#Product_section_bottom", "slide_in")
    .addTo(controller_5); // assign the scene to the controller

  // End of Scroll magic
  function goToProduct() {
    $("html,body").animate(
      {
        scrollTop: $(".homepage_product_title ").offset().top,
      },
      "slow"
    );
  }
});

$(".rc_block__type__autodeliver").click(function () {
  $("#rc_autodeliver_options").show();
});
$(".rc_block__type__onetime").click(function () {
  $("#rc_autodeliver_options").hide();
});

$(".add-to-cart").click(function (event) {
  if ($(".product-single__variants").val() == 43223353688307) {
    var wand_wale_90_pack_id = "41993294184635";
    var quantity_value = $(".js-qty__num").val();
    var value = $(".Selected_selling_plan").val();
    if (value == "autodeliver") {
      event.preventDefault();
      var frequency_value = $(".rc_select__frequency").val();
      var unit = "days";
      var data = new Array();
      data.push({
        quantity: quantity_value,
        id: wand_wale_90_pack_id,
        "properties[shipping_interval_frequency]": frequency_value,
        "properties[shipping_interval_unit_type]": unit,
      });

      console.log(data);
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { items: data },
        dataType: "json",
        success: function () {
          window.location.href = "/cart";
        },
      });
    }
  }
});

$(".js-qty__adjust").click(function (event) {

  setTimeout(function () {
    var currentQty = parseFloat($(".js-qty__num").val());
    console.log(currentQty);

    $(".Product_variant_pricing").each(function () {
      var currentPrice = parseFloat($(this).attr("data-price"));
      var comparePrice = parseFloat($(this).attr("data-compare-price"));
      currentPrice = currentPrice * currentQty;
      comparePrice = comparePrice * currentQty;
      currentPrice = (currentPrice / 100).toFixed(2);
      comparePrice = (comparePrice / 100).toFixed(2);
      if (typeof comparePrice == "undefined") {
        $(this)
          .find("span")
          .text("$ " + currentPrice);
        $(this).find("s").find("span").hide();
      } else {
        $(this)
          .find("span")
          .text("$ " + currentPrice);
        $(this).find("s").find("span").show();
        $(this)
          .find("s")
          .find("span")
          .text("$ " + comparePrice);
      }
    });

    $(".Product_price_discount").each(function () {
      var currentDiscount = parseFloat($(this).attr("data-discount"));
      currentDiscount = ((currentDiscount * currentQty) / 100).toFixed(2);
      $(this)
        .find("span")
        .text("$ " + currentDiscount);
    });
  }, 50);
});

// ----------- Quiz Section -----------

$(".quiz_show_more_button").click(function () {
  $(".Quiz_content").hide();
  $(".whole_quiz_offer_Section").slideDown();
  $("html, body").animate(
    {
      scrollTop: $("#quiz_offer_section__js").offset().top,
    },
    1000
  );
  $(".Quiz_Hidden_Text").show();
});

$(".reminder_button").click(function () {
  $("html, body").animate(
    {
      scrollTop: $("#quiz_offer_section__js").offset().top,
    },
    1000
  );
});

$(".quiz-selector").change(function () {
  $(this)
    .parent(".variant_selector_container")
    .parent(".quiz-offer-product-card__inner")
    .parent(".quiz-offer-product-card")
    .find(".quiz-offer-product-card__variant__id")
    .val($(this).val());
  // Price selector
  var current_id = $(this).val();
  var current_price;
  var current_compare_at_price;
  var current_prices = $(".quiz-price-container").find(".money").text();
  if (current_prices.indexOf("$") !== -1) {
    var currency = "$";
  }
  if (current_prices.indexOf("£") !== -1) {
    var currency = "£";
  }
  if (current_prices.indexOf("€") !== -1) {
    var currency = "€";
  }
  $(".Quiz-offer-product-card-price__js").each(function () {
    if ($(this).attr("data_id") == current_id) {
      current_price = parseFloat($(this).attr("data_price")) / 100;
      current_compare_at_price =
        parseFloat($(this).attr("data_compare_price")) / 100;
    }
  });
  console.log(
    "changed variant",
    current_id,
    current_price,
    current_compare_at_price,
    currency
  );
  $(this)
    .parent(".variant_selector_container")
    .parent(".quiz-offer-product-card__inner")
    .parent(".quiz-offer-product-card")
    .find(".quiz-price-container")
    .find(".money")
    .text(currency + " " + current_price);
  $(this)
    .parent(".variant_selector_container")
    .parent(".quiz-offer-product-card__inner")
    .parent(".quiz-offer-product-card")
    .find(".quiz-offer__product_richtext")
    .find(".quiz-price-container")
    .find("strike")
    .find(".money")
    .text(currency + " " + current_compare_at_price);

  $(this)
    .parent(".variant_selector_container")
    .parent(".quiz-offer-product-card__inner")
    .parent(".quiz-offer-product-card")
    .find(".offer_product_image")
    .hide();
  $(".offer_product_image").each(function () {
    if ($(this).attr("variant_id") == current_id) {
      $(this).show();
    }
  });
});

$(window).resize(function () {
  if ($(window).width() < 900) {
    $(".quiz-product-offer-container").addClass("quiz-mobile-container");
    $(".quiz-mobile-container").slick({
      arrows: false,
      centerMode: true,
      dots: false,
    });
  }
  if ($(window).width() > 900) {
    $(".quiz-product-offer-container").removeClass("quiz-mobile-container");
  }
});
if ($(window).width() < 900) {
  $(".quiz-product-offer-container").addClass("quiz-mobile-container");
  $(".quiz-mobile-container").slick({
    arrows: false,
    centerMode: true,
    dots: true,
  });
}

$(".quiz_show_more_button").click(function () {
  $(".text-middle-image-template").show();
  $(".metrics-section__wrapper").show();
  $(".new-comment-slider-template").show();
  setTimeout(function () {
    $(".slick-slider").slick("refresh");
  }, 1000);
});

$(".img-section__button").click(function () {
  $("html, body").animate(
    {
      scrollTop: $("#quiz_offer_section__js").offset().top,
    },
    2000
  );
});

$(".section-button__shop").click(function () {
  $("html, body").animate(
    {
      scrollTop: $("#quiz_offer_section__js").offset().top,
    },
    2000
  );
});

// Redirecte
// Phoenix

// if(window.location.href.indexOf("/products/the-wand-1") != -1)
// {
//   window.location.replace("https://drinkpurewine.com/products/the-wand-subscription-sale");
// }

// if (window.location.href.indexOf("the-phoenix-bio-pod-refill-8-pack") != -1) {
//   if (window.location.href.indexOf('the-phoenix-bio-pod-refill-8-pack-1') != -1) {

//   }
//   else {
//     var url = window.location.href;
//     var utm_url = url.replace('https://drinkpurewine.com/products/the-phoenix-bio-pod-refill-8-pack', '');

//     window.location.replace("https://drinkpurewine.com/products/the-phoenix-bio-pod-refill-8-pack-1" + utm_url);
//   }
// }

if (
  window.location.href.indexOf(
    "drinkpurewine.com/products/bio-pod-refill-30-off"
  ) != -1
) {
  var url = window.location.href;
  var utm_url = url.replace(
    "https://drinkpurewine.com/products/bio-pod-refill-30-off",
    ""
  );

  window.location.replace(
    "https://drinkpurewine.com/products/the-phoenix-bio-pod-refill-8-pack-1" +
      utm_url
  );
}

if (window.location.href.indexOf("/pages/trial-pack-landing") != -1) {
  var url = window.location.href;
  var utm_url = url.replace(
    "https://drinkpurewine.com/pages/trial-pack-landing",
    ""
  );

  window.location.replace(
    "https://drinkpurewine.com/products/the-purewine-trial-pack" + utm_url
  );
}

if (window.location.href.indexOf("/collections/all") != -1) {
  if (window.location.href.indexOf("/collections/all-products") != -1) {
  } else {
    var url = window.location.href;
    var utm_url = url.replace("https://drinkpurewine.com/collections/all", "");

    window.location.replace(
      "https://drinkpurewine.com/collections/all-products" + utm_url
    );
  }
}

if (
  window.location.href ==
  "https://drinkpurewine.com/collections/collection-page"
) {
  window.location.replace("https://drinkpurewine.com/collections/all-products");
}
if (window.location.href == "https://drinkpurewine.com/collections/the-wand") {
  window.location.replace("https://drinkpurewine.com/collections/all-products");
}
if (
  window.location.href == "https://drinkpurewine.com/collections/the-wave-1"
) {
  window.location.replace("https://drinkpurewine.com/collections/all-products");
}
if (
  window.location.href == "https://drinkpurewine.com/collections/subscribe-save"
) {
  window.location.replace("https://drinkpurewine.com/collections/all-products");
}
if (
  window.location.href ==
  "https://drinkpurewine.com/products/the-phoenix-starter-kit-new"
) {
  window.location.replace(
    "https://drinkpurewine.com/products/the-phoenix-starter-kit-1"
  );
}

if (
  window.location.href ==
  "https://drinkpurewine.com/products/the-phoenix-starter-kit"
) {
  window.location.replace(
    "https://drinkpurewine.com/products/the-phoenix-starter-kit-1"
  );
}

if (window.location.href == "https://drinkpurewine.com/collections/all") {
  window.location.replace("https://drinkpurewine.com/collections/all-products");
}
if (
  window.location.href == "https://drinkpurewine.com/pages/new-phoenix-landing"
) {
  window.location.replace(
    "https://drinkpurewine.com/products/the-phoenix-starter-kit-1"
  );
}
if (
  window.location.href == "https://drinkpurewine.com/pages/phoenix-landing-old"
) {
  window.location.replace(
    "https://drinkpurewine.com/products/the-phoenix-starter-kit-1"
  );
}
// if (window.location.href=="https://drinkpurewine.com/products/the-phoenix-starter-kit-2"){
//   window.location.replace("https://drinkpurewine.com/products/the-phoenix-starter-kit-1");
// }
// if (window.location.href=='https://drinkpurewine.com/pages/phoenix-starter-kit'){
//   window.location.replace('https://drinkpurewine.com/products/the-phoenix-starter-kit-1 ');
// }

// The Wand
if (
  window.location.href ==
  "https://drinkpurewine.com/products/the-wand-3-pack-special-edition-pink"
) {
  window.location.replace("https://drinkpurewine.com/products/the-wand-1");
}
if (
  window.location.href ==
  "https://drinkpurewine.com/products/silver-wand-3-pack"
) {
  window.location.replace("https://drinkpurewine.com/products/the-wand-1");
}
if (
  window.location.href ==
  "https://drinkpurewine.com/products/the-wand-box-of-30"
) {
  window.location.replace("https://drinkpurewine.com/products/the-wand-1");
}
// if (window.location.href == "https://drinkpurewine.com/products/the-wand-30-pack-silver") {
//   window.location.replace("https://drinkpurewine.com/products/the-wand-1");
// }
if (
  window.location.href == "https://drinkpurewine.com/products/the-wand-8-pack"
) {
  window.location.replace("https://drinkpurewine.com/products/the-wand-1");
}
if (
  window.location.href ==
  "https://drinkpurewine.com/products/the-wand-8-pack-pink"
) {
  window.location.replace("https://drinkpurewine.com/products/the-wand-1");
}
if (
  window.location.href ==
  "https://drinkpurewine.com/products/the-wand-8-pack-red"
) {
  window.location.replace("https://drinkpurewine.com/products/the-wand-1");
}
if (
  window.location.href ==
  "https://drinkpurewine.com/products/the-wand-8-pack-silver"
) {
  window.location.replace("https://drinkpurewine.com/products/the-wand-1");
}
if (
  window.location.href ==
  "https://drinkpurewine.com/products/the-wand-8-pack-silver-gold"
) {
  window.location.replace("https://drinkpurewine.com/products/the-wand-1");
}
if (
  window.location.href ==
  "https://drinkpurewine.com/products/the-wand-90-party-pack"
) {
  window.location.replace("https://drinkpurewine.com/products/the-wand-1");
}
// The wave
if (
  window.location.href == "https://drinkpurewine.com/products/the-wave-3-pack"
) {
  window.location.replace("https://drinkpurewine.com/products/the-wave-3");
}
if (window.location.href == "https://drinkpurewine.com/products/the-wave-1") {
  window.location.replace("https://drinkpurewine.com/products/the-wave-3");
}

if (window.location.href.indexOf("elixir-square-wine-glasses-set-of-4") != -1) {
  window.location.replace("https://drinkpurewine.com/collections/all-products");
}
if (window.location.href.indexOf("elixir-wine-carafe-50-off") != -1) {
  window.location.replace("https://drinkpurewine.com/collections/all-products");
}
 var data_value_w1;
 var data_value_w2;
$(".wrapper_1 .variant-input").click(function (event) {
   data_value_w1 = $(this).attr("data-value");
//console.log('pack clicked'+ data_value);
});
$(".wrapper_2 .variant-input").click(function (event) {
   data_value_w2 = $(this).attr("data-value");
//console.log('Color clicked'+ data_value);
});
$(".variant-input").click(function (event) {
  event.stopImmediatePropagation();
  // Checking it is one time or autodelivery
  var delivery_mode = $(".Subscribtion_widget_selector__js.active").attr(
    "data"
  );
  
  var data_value = $(this).attr("data-value");

  setTimeout(function () {
    var page_url = window.location.href;
    var variant_id = page_url.substr(page_url.length - 14);

    if (page_url.indexOf("?variant=") != -1) {
    } else {
      variant_id = $(".Product_price_current_identifier__js").attr("data-id");
    }

    if (typeof delivery_mode == "undefined") {
      delivery_mode = "onetime";
    }

    // Subscription variants switch
    // console.log(delivery_mode, 'Delivery mode');
    if (delivery_mode == "autodeliver") {
      /*                
      if (data_value === "90 Pack") {
          $(".product-single__variants").attr("subscribe_id",  43914399318259);
      } else if (data_value === "USA") {
          $(".product-single__variants").attr("subscribe_id", 45949427974387);
      } 
        
      if (data_value === "30 Pack") {
          $(".product-single__variants").attr("subscribe_id", 43914401644787);
      }  else if (data_value === "USA") {
          $(".product-single__variants").attr("subscribe_id", 45948860891379);
       }  
      
            */
       
      if (data_value === "90 Pack") {
          $(".product-single__variants").attr("subscribe_id", 43914399318259);
        
      } 
       
      if (data_value === "30 Pack") {
          $(".product-single__variants").attr("subscribe_id", 43914401644787);
      }

      
      
      console.log(data_value_w1);
      console.log(data_value_w2);
      
        if (data_value_w1 === "30 Pack" && data_value_w2 === "Silver") {
                 $(".product-single__variants").attr("subscribe_id", 43914401644787);
          $(".product-single__variants").attr("pw_product_slug", 'the-wand-30-pack-subscription-new');
      }   else if (data_value_w1 === "30 Pack" && data_value_w2 === "USA") {
              $(".product-single__variants").attr("subscribe_id", 45948860891379);
          $(".product-single__variants").attr("pw_product_slug", 'the-wand-30-pack-usa-subscription-new');
      }   else if (data_value_w1 === "90 Pack" && data_value_w2 === "Silver") {
              $(".product-single__variants").attr("subscribe_id", 43914399318259);
          $(".product-single__variants").attr("pw_product_slug", 'the-wand-90-pack-subscription-new');
      }   else if (data_value_w1 === "90 Pack" && data_value_w2 === "USA") {
              $(".product-single__variants").attr("subscribe_id", 45949427974387);
          $(".product-single__variants").attr("pw_product_slug", 'the-wand-90-pack-usa-subscription-new');
      }

 
      
      /*      
      if (data_value === "USA") {
                 $(".product-single__variants").attr("subscribe_id", 45949427974387);
      }  
            
      if (data_value === "USA") {
              $(".product-single__variants").attr("subscribe_id", 45948860891379);
      }
            */


      if (data_value == "8-Pack") {
        $(".product-single__variants").attr("subscribe_id", 43914389029107);
          $(".product-single__variants").attr("pw_product_slug", 'the-phoenix-bio-pod-refill-subscribe-2');
      }
      if (data_value == "24-Pack") {
        $(".product-single__variants").attr("subscribe_id", 43914389061875);
          $(".product-single__variants").attr("pw_product_slug", 'the-phoenix-bio-pod-refill-subscribe-2');
      }

 

      
      
    }

    // Pricing switch
    $(".Product_variant_pricing").hide();
    if (delivery_mode == "onetime") {
      $(".Product_variant_pricing.onetime").each(function () {
        if ($(this).attr("data-id") == variant_id) {
          $(this).show();
        }
      });
    }
    if (delivery_mode == "autodeliver") {
      $(".Product_variant_pricing.autodelivery").each(function () {
        if ($(this).attr("data-id") == variant_id) {
          $(this).show();
        }
      });
    }




    
    // Discount switch
    $(".Product_price_discount").hide();
    if (delivery_mode == "onetime") {
      $(".Product_price_discount.onetime").each(function () {
        if ($(this).attr("data-id") == variant_id) {
          $(this).show();
        }
      });
    }
    if (delivery_mode == "autodeliver") {
      $(".Product_price_discount.autodelivery").each(function () {
        if ($(this).attr("data-id") == variant_id) {
          $(this).show();
        }
      });
    }

    // Sale Tag switch
    $(".Product_price_sale_tag").hide();
    if (delivery_mode == "onetime") {
      $(".Product_price_sale_tag.onetime").each(function () {
        if ($(this).attr("data-id") == variant_id) {
          $(this).show();
        }
      });
    }
    if (delivery_mode == "autodeliver") {
      $(".Product_price_sale_tag.autodelivery").each(function () {
        if ($(this).attr("data-id") == variant_id) {
          $(this).show();
        }
      });
    }
  }, 50);

  setTimeout(function () {
    var page_url = window.location.href;
    if (page_url.indexOf("?variant=") != -1) {
    } else {
      variant_id = $(".Product_current_price").attr("data-id");
    }
  }, 50);

  // *** Environment setup here, image filtering and etc

  // console.log("clicked");
  //   Set
  if (data_value == "3 Pack") {
    // Reset
    $(".variant-input").removeClass("active_variants_buttons");
    $(".variant-input").each(function () {
      if ($(this).attr("data-value") == "Silver") {
        $(this).addClass("active_variants_buttons");
        if ($(this).hasClass("trigger_1")) {
          $(this).find("input").click();
        }
      }
    });
  }
  if (data_value == "8 Pack") {
    // Reset
    $(".variant-input").removeClass("active_variants_buttons");
    $(".variant-input").each(function () {
      if (
        $(this).attr("data-value") == "Silver" ||
        $(this).attr("data-value") == "Pink" ||
        $(this).attr("data-value") == "Red" ||
        $(this).attr("data-value") == "Silver & Gold" || 
        $(this).attr("data-value") == "Eco" 
      ) {
        $(this).addClass("active_variants_buttons");
        if ($(this).hasClass("trigger_1")) {
          $(this).find("input").click();
        }
      }
    });
  }
  if (data_value == "24 Pack") {
    // Reset
    $(".variant-input").removeClass("active_variants_buttons");
    $(".variant-input").each(function () {
      if (
        $(this).attr("data-value") == "Eco" 
      ) {
        $(this).addClass("active_variants_buttons");
        if ($(this).hasClass("trigger_6")) {
          $(this).find("input").click();
        }
      }
    });
  }
  if (data_value == "30 Pack") {
    // Reset
    $(".variant-input").removeClass("active_variants_buttons");
    $(".variant-input").each(function () {
      if (
        $(this).attr("data-value") == "Silver" ||
        $(this).attr("data-value") == "USA" ||
        $(this).attr("data-value") == "Variety (+10 FREE Wands)" || 
        $(this).attr("data-value") == "Eco"
      ) {
        $(this).addClass("active_variants_buttons");
        if ($(this).hasClass("trigger_1")) {
          $(this).find("input").click();
        }
      }
    });
  }
  if (data_value == "40 Pack") {
    // Reset
    $(".variant-input").removeClass("active_variants_buttons");
    $(".variant-input").each(function () {
      if (
        $(this).attr("data-value") == "Variety" ||
        $(this).attr("data-value") == "Silver & Gold" ||
        $(this).attr("data-value") == "Red" ||
        $(this).attr("data-value") == "Pink" || 
        $(this).attr("data-value") == "Eco"
      ) {
        $(this).addClass("active_variants_buttons");
        if ($(this).hasClass("trigger_3")) {
          $(this).find("input").click();
        }
      }
    });
  }

    /* 
  if (data_value == "90 Pack") {
    // Reset
    $(".variant-input").removeClass("active_variants_buttons");
    $(".variant-input").each(function () {
      if ($(this).attr("data-value") == "Silver" ) {
        $(this).addClass("active_variants_buttons");
        if ($(this).hasClass("trigger_1")) {
          $(this).find("input").click();
        }
      }
    });
  }
*/
if (data_value == "90 Pack") {
    // Reset
    $(".variant-input").removeClass("active_variants_buttons");
    $(".variant-input").each(function () {
      if ($(this).attr("data-value") == "Silver" ||
        $(this).attr("data-value") == "USA") {
        $(this).addClass("active_variants_buttons");
        if ($(this).hasClass("trigger_1")) {
          $(this).find("input").click();
        }
      }
    });
  } 
  
  // For wand bundle
  // Reset
  if (window.location.href.indexOf("the-wand-color-bundle") != -1) {
    $(".variant-input").removeClass("active_variants_buttons");
    $(".variant-input").each(function () {
      if (
        $(this).attr("data-value") == "Silver & Gold" ||
        $(this).attr("data-value") == "Silver & Red" ||
        $(this).attr("data-value") == "Silver & Pink"
      ) {
        $(this).addClass("active_variants_buttons");
      }
    });
  }

  setTimeout(function () {
    const url_link = window.location.href;
    const idLength = 14; // ID Length - (42810151567603)
    var selected_variant = url_link.substring(url_link.length - idLength);
    //     Set current variant id on first load
    if (
      selected_variant.indexOf("/") !== -1 ||
      selected_variant.indexOf("-") !== -1
    ) {
      selected_variant = $(".variant_position").attr("first_variant_id");
    }

    /*  -----------FILTERING CONDITIONS------------
      * Image Alt Text: ('variant-color') or ('variant-color_variant-size');
      * Main item images must be ordered first in shopify product editor,
      because other images labeled with the same color will be shown as well, therefore ensure the right order;
    

        -----------Possible optimization for readability and reduced code------------
      * '[variant-title]' could be generated with color going first, only then size
    */

    //  __________Selected Variant Properties__________
    const variantTitle = $(
      `[variant_id="${selected_variant}"].variant_position`
    )
      .attr("variant-title")
      .toLowerCase();
    let color = variantTitle;
    let size;

    if (variantTitle.indexOf("/") !== -1) {
      const properties = variantTitle.split(" / ");
      size = toKebabCase(properties[0]);
      color = toKebabCase(properties[1]);
    } else {
      color = toKebabCase(variantTitle);
    }

    /**
     ** Changes string syntax to match that of an image alt (kebab-case).
     ** Add more delimiters for other variations
     * @param {string} str - 'Rose Gold', 'Silver & Gold', '8 Pack' ...
     * @returns 'rose-gold', 'silver-gold', '8-pack' ...
     */
    function toKebabCase(str) {
      const syntaxDelimiters = [" & ", " "];
      let result = str;

      syntaxDelimiters.forEach((symbol) =>
        result.indexOf(symbol) !== -1
          ? (result = result.split(symbol).join("-"))
          : null
      );
      return result;
    }

    //  __________Filtering Images__________
    const colorFilter = `[data-color="all"], [data-color="${color}"]`;

    /**
     * Adds size filter if size is defined. The filter is of elements either:
     ** With data-color and data-size matched;
     ** Just data-color matched AND data-size is not specified
     *
     ** If neither data-color AND data-size is specified - will display for each variant.
     */
    const sizeFilter =
      size != undefined
        ? `[data-size="${size}"], ${colorFilter}[data-size=""]`
        : "";

    // const sizeFilter = size != undefined ? `[data-size="${size}"], ${colorFilter}[data-size=""]` : '';

    let filter = colorFilter + sizeFilter;
    $(".product_image_container").animate({ opacity: 0.05 }, 50);
    $(".product_images_carousel").slick("slickUnfilter");
    $(".product_images_carousel__navigation").slick("slickUnfilter");

    $(".product_images_carousel").slick("slickFilter", filter);
    $(".product_images_carousel__navigation").slick("slickFilter", filter);

    $(".product_images_carousel_both .slick-track").addClass(
      "smooth-transition"
    );
    setTimeout(() => {
      $(".product_image_container").animate({ opacity: 1 }, 250);
    }, 50);

    $(".product_images_carousel").slick("slickGoTo", 0);
    $(".product_images_carousel__navigation").slick("slickGoTo", 0);
  }, 200);
});

$(document).ready(function () {
  setTimeout(() => {
    $(".product_images_carousel_both .slick-track").addClass(
      "smooth-transition"
    );
  }, 900);
});

// Informative Landing

$(document).ready(function () {
  $(".landing-offer-flex").slick({
    arrows: false,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0605/5487/1040/files/Icon_ionic-ios-arrow-back-min.png?v=1643876777'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0605/5487/1040/files/Icon_ionic-ios-arrow-back-1-min.png?v=1643876777'/></button>",
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    centerMode: true,
    centerPadding: "40px",
  });

  $(".landing-image-gallery__carousel").slick({
    arrows: false,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0605/5487/1040/files/Icon_ionic-ios-arrow-back-min.png?v=1643876777'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0605/5487/1040/files/Icon_ionic-ios-arrow-back-1-min.png?v=1643876777'/></button>",
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    centerMode: true,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 900,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "40px",
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".button-scroll-to-main-section__js").click(function () {
    $("html, body").animate(
      {
        scrollTop: $(".whole_quiz_landing_Section").offset().top,
      },
      1000
    );
  });
});

// (Optional) Active an item if it has the class "is-active"
$(".accordion > .accordion-item.is-active")
  .children(".accordion-panel")
  .slideDown();

$(".accordion > .accordion-item").click(function () {
  // Cancel the siblings
  $(this)
    .siblings(".accordion-item")
    .removeClass("is-active")
    .children(".accordion-panel")
    .slideUp();
  // Toggle the item
  $(this)
    .toggleClass("is-active")
    .children(".accordion-panel")
    .slideToggle("ease-out");
});

// homePage-logos

$(".homePage-desktop-logo__container").slick({
  slidesToShow: 3,
  dots: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 749,
      settings: {
        slidesToShow: 1,
        dots: true,
        arrows: false,
      },
    },
  ],
});

$(window).resize(function () {
  $(".homePage-desktop-logo__container").slick("refresh");
});
// homePage-redesign-benefit

$(".homePage-mobile__container").slick({
  arrows: false,
  slidesToShow: 3,
  dots: true,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        arrows: false,
        slidesToShow: 1,
        dots: true,
        centerMode: false,
      },
    },
  ],
});

// (Optional) Active an item if it has the class "is-active"
$(".accordion_product_page > .accordion-item_product_page.is-active")
  .children(".accordion-panel_product_page")
  .slideDown();

$(".accordion_product_page > .accordion-item_product_page").click(function () {
  // Cancel the siblings
  $(this)
    .siblings(".accordion-item_product_page")
    .removeClass("is-active")
    .children(".accordion-panel_product_page")
    .slideUp();
  // Toggle the item
  $(this)
    .toggleClass("is-active")
    .children(".accordion-panel_product_page")
    .slideToggle("ease-out");
});

// Loading animations

$(document).ready(function () {
  setTimeout(function () {
    $(".main-content").addClass("loaded");
  }, 100);

  // Landing javscript

  $(".Landing_lifestyle_gallery").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "200px",
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1500,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: "60px",
          slidesToShow: 1,
        },
      },
    ],
  });

  $(".Landing_video").mouseover(function () {
    var video = $(this).get(0);
    if (video.paused) {
      $(".Landing_video_play_icon").css("opacity", "1");
    } else {
      $(".Landing_video_pause_icon").css("opacity", "1");
    }
  });

  $(".Landing_video").mouseout(function () {
    var video = $(this).get(0);
    if (video.paused) {
      $(".Landing_video_pause_icon").css("opacity", "0");
    } else {
      $(".Landing_video_play_icon").css("opacity", "0");
      $(".Landing_video_pause_icon").css("opacity", "0");
    }
  });

  $(".Landing_video").click(function () {
    var video = $(this).get(0);
    if (video.paused) {
      $(".Landing_video_pause_icon").css("opacity", "0");
      $(".Landing_video_play_icon").css("opacity", "1");
    } else {
      $(".Landing_video_play_icon").css("opacity", "0");
      $(".Landing_video_pause_icon").css("opacity", "0");
    }
  });

  $(".Landing_reviews_container_mob").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "20px",
    dots: true,
  });

  $(".Landing_main_cta_button").click(function () {
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $(".product-grid-area").offset().top - 100,
      },
      500
    );
  });

  $(".js-qty__adjust").click(function () {
    var data_product = $(".js-qty__wrapper").attr("data-product");
    if (data_product.indexOf("Trial Pack") != -1) {
      if ($(".js-qty__num").val() > 99) {
        $(".js-qty__num").val(3);
      }
    }
  });
});

// Phoenix landing js

$(".phoenix-funnel-scroll-btn").click(function () {
  $([document.documentElement, document.body]).animate(
    {
      scrollTop: $("#page-top").offset().top,
    },
    200
  );
});

// BF
$(".Bf_offer_button").click(function () {
  if ($(window).width() > 800) {
    $([document.documentElement, document.body]).animate(
      {
        scrollTop:
          $(".Homepage_featured_collection_container").offset().top - 150,
      },
      200
    );
  } else {
    $([document.documentElement, document.body]).animate(
      {
        scrollTop:
          $(".Homepage_featured_collection_first_cell").offset().top - 50,
      },
      200
    );
  }
});

$(".Offer_landing_hero_button").click(function () {
  $([document.documentElement, document.body]).animate(
    {
      scrollTop: $(".Offer_landing_offer_products_container").offset().top - 70,
    },
    200
  );
});

$(".Featured_collection_product_card_atc_button").click(function () {
  var currentVariant = $(this).attr("data-id");
  $(".cart-link__bubble").addClass("cart-link__bubble--visible");
  var atcButton = $(this);
  var atcText = atcButton.text();
  atcButton.text("Adding...");

  data = {
    id: currentVariant,
    quantity: 1,
  };

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      console.log(data);
      createCart();
      setTimeout(function () {
        $(".Slide_cart_whole").css("right", "0px");
        $(".Slide_cart_overlay").show();
        atcButton.text(atcText);
      }, 500);
    },
  });
});

// Quick add feature
$(document).on("click", ".Quick_add_quantity_minus", function () {
  var current_qty = $(this)
    .parent(".Quick_add_quanity_container")
    .attr("data-quantity");
  var current_id = parseFloat(
    $(this).parent(".Quick_add_quanity_container").attr("data-id")
  );
  current_qty--;
  data = {
    id: current_id,
    quantity: current_qty,
  };

  console.log(data);
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: data,
    dataType: "json",
    success: function () {
      console.log(data);
    },
  });

  setTimeout(function () {
    jQuery.getJSON("/cart.js", function (cart) {
      console.log(cart);
      const cart_item = [];
      for (var i = 0; i < cart.items.length; i++) {
        var quantity = cart.items[i].quantity;
        var price = ((cart.items[i].price * quantity) / 100).toFixed(2);
        cart_item[i] =
          `
        <div class="Quick_add_product_line">
              <div>
                  <img src="` +
          cart.items[i].image +
          `">
              </div>
              <div>
                  <h1 class="Quick_add_product_title">
                  ` +
          cart.items[i].product_title +
          `
                  </h1>
                  <h1 class="Quick_add_product_variant_title">
                  ` +
          cart.items[i].variant_title +
          `
                  </h1>
                  <h1 class="Quick_add_product_price"><span class="Quick_add_product_current_price">$` +
          price +
          `</span></h1>
              </div>
              <div>
                  <div class="Quick_add_quanity_container" data-quantity="` +
          quantity +
          `" data-id="` +
          cart.items[i].id +
          `">
                      <div class="Quick_add_quantity_minus">-</div>
                      <div class="Quick_add_quantity_num">` +
          quantity +
          `</div>
                      <div class="Quick_add_quantity_plus">+</div>
                  </div>
              </div>
          </div>
        `;
      }
      $(".Quick_add_cart_content").html(cart_item);
    });
  }, 500);
});

$(document).on("click", ".Quick_add_quantity_plus", function () {
  var current_qty = $(this)
    .parent(".Quick_add_quanity_container")
    .attr("data-quantity");
  var current_id = parseFloat(
    $(this).parent(".Quick_add_quanity_container").attr("data-id")
  );
  current_qty++;
  data = {
    id: current_id,
    quantity: current_qty,
  };

  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: data,
    dataType: "json",
    success: function () {
      console.log(data);
    },
  });

  setTimeout(function () {
    jQuery.getJSON("/cart.js", function (cart) {
      console.log(cart);
      const cart_item = [];
      for (var i = 0; i < cart.items.length; i++) {
        var quantity = cart.items[i].quantity;
        var price = ((cart.items[i].price * quantity) / 100).toFixed(2);
        cart_item[i] =
          `
        <div class="Quick_add_product_line">
              <div>
                  <img src="` +
          cart.items[i].image +
          `">
              </div>
              <div>
                  <h1 class="Quick_add_product_title">
                  ` +
          cart.items[i].product_title +
          `
                  </h1>
                  <h1 class="Quick_add_product_variant_title">
                  ` +
          cart.items[i].variant_title +
          `
                  </h1>
                  <h1 class="Quick_add_product_price"><span class="Quick_add_product_current_price">$` +
          price +
          `</span></h1>
              </div>
              <div>
                  <div class="Quick_add_quanity_container" data-quantity="` +
          quantity +
          `" data-id="` +
          cart.items[i].id +
          `">
                      <div class="Quick_add_quantity_minus">-</div>
                      <div class="Quick_add_quantity_num">` +
          quantity +
          `</div>
                      <div class="Quick_add_quantity_plus">+</div>
                  </div>
              </div>
          </div>
        `;
      }
      $(".Quick_add_cart_content").html(cart_item);
    });
  }, 500);
});

$(".Quick_add_close_button").click(function () {
  $(".Quick_add_popup").css("opacity", "0");
  setTimeout(function () {
    $(".Quick_add_popup").hide();
  }, 500);
});

// $(document).ready(function(){

//   var cname = 'popup_value_pw';
//     function getCookie(cname) {
//       let name = cname + "=";
//       let decodedCookie = decodeURIComponent(document.cookie);
//       let ca = decodedCookie.split(';');
//       for(let i = 0; i <ca.length; i++) {
//         let c = ca[i];
//         while (c.charAt(0) == ' ') {
//           c = c.substring(1);
//         }
//         if (c.indexOf(name) == 0) {
//           return c.substring(name.length, c.length);
//         }
//       }
//       return "";
//     }
// });

$(".Phoenix_product_banner").click(function () {
  $("html, body").animate(
    {
      scrollTop: $(".product-grid-area").offset().top - 150,
    },
    500
  );
});

function changeGift(toAdd) {
  var poppedStock = toAdd.pop();
  data = {
    quantity: poppedStock.quantity_id,
    id: poppedStock.variant_id,
    par: poppedStock.par,
  };
  var par = data.par;
  if (par == "add") {
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function (data) {
        if (toAdd == 0) {
          console.log("All gift setup is complete!!!");
          buildCart();
        } else {
          changeGift(toAdd);
        }
      },
    });
  } else if (par == "change") {
    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: data,
      dataType: "json",
      success: function (data) {
        if (toAdd == 0) {
          console.log("All gift setup is complete!!!");
          buildCart();
        } else {
          changeGift(toAdd);
        }
      },
    });
  }
}

function freeGiftSale() {
  var cart_item = [];
  jQuery.getJSON("/cart.js", function (cart) {
    // Flash sale free gifts

    var decanter_gift_in_Cart = 0;
    var wine_glass_gift_in_Cart = 0;
    var freeDecanterGiftId = 43657955737843;
    var decanterTriggerId = 42006960603323;
    var freeGlasseGiftId = 43657965240563;
    var glassesTriggerId = 42503931101427;
    var decanterTrigger_in_cart = 0;
    var glassesTrigger_in_cart = 0;
    var gift_in_cart = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].id == freeDecanterGiftId) {
        decanter_gift_in_Cart += cart.items[i].quantity;
      }
      if (cart.items[i].id == freeGlasseGiftId) {
        wine_glass_gift_in_Cart += cart.items[i].quantity;
      }
      if (cart.items[i].id == decanterTriggerId) {
        decanterTrigger_in_cart += cart.items[i].quantity;
      }
      if (cart.items[i].id == glassesTriggerId) {
        glassesTrigger_in_cart += cart.items[i].quantity;
      }
    }

    if (decanterTrigger_in_cart > 0 || glassesTrigger_in_cart > 0) {
      var glassesgiftQty = Math.floor(glassesTrigger_in_cart / 2);
      var decantergiftQty = Math.floor(decanterTrigger_in_cart / 2);

      if (decanter_gift_in_Cart == 0) {
        var decanterPar = "add";
      } else if (decanter_gift_in_Cart > 0) {
        var decanterPar = "change";
      }

      if (wine_glass_gift_in_Cart == 0) {
        var glassesPar = "add";
      } else if (wine_glass_gift_in_Cart > 0) {
        var glassesPar = "change";
      }

      var Data = new Array();
      dataArray = [freeDecanterGiftId, freeGlasseGiftId];
      quantityArray = [decantergiftQty, glassesgiftQty];
      parArray = [decanterPar, glassesPar];
      console.log(quantityArray);
      for (j = 0; j < dataArray.length; j++) {
        Data.push({
          variant_id: dataArray[j],
          quantity_id: quantityArray[j],
          par: parArray[j],
        });
      }
      console.log(Data, "Data is");
      changeGift(Data);
      // }
    }
  });
}

function freeGiftFromOffer() {
  jQuery.getJSON("/cart.js", function (cart) {
    if (cart.item_count >= 1) {

      var party = 44857096700147;
 
      var partyQty = 0;

      var updatedParty = 0;


      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].id == party) {
           partyQty += cart.items[i].quantity;
        }
      }

      // SilverGold gift selection
      if ( partyQty > 12){
        var dataParty = {
              id: party,
              quantity: 12,
        };
        if ( partyQty != 12){
          updatedParty = 1;
        }
      }
      


      // adjusting cart for silver updates
      if (updatedParty == 1){
          jQuery.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: dataParty,
            dataType: "json",
            success: function () {
              console.log("Changed Gift Quantity");
              alert('Maximum 12 units available.');
            },
          });
      }
      
    }
  });
}

function buildCart() {
  freeGiftFromOffer();
  setTimeout(function () {
    var cart_item = [];
    jQuery.getJSON("/cart.js", function (cart) {
      
      // ======== Start of email free gift setup in createCart(); ==============
      // Checking for free gift in cart
      var freeEmailGiftVariant = 32638154539089;
      var gift_in_cart = 0;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].id == freeEmailGiftVariant) {
          gift_in_cart += cart.items[i].quantity;
        }
      }

      var freeDecanterGiftId = 43657955737843;
      var freeGlasseGiftId = 43657965240563;

      // Setting up environment with/without free gift

      if (gift_in_cart > 0 && cart.total_price < 2500) {
        $(".Slide_cart_checkout_button__js").addClass("Disabled");
        $(".Checkout_button_reserve_message").text(
          "Your purchase must be $25 and over to get the Free Gift!"
        );
      } else {
        $(".Slide_cart_checkout_button__js").removeClass("Disabled");
        $(".Checkout_button_reserve_message").text(
          "Items in your cart will remain for 1 hour but they are not reserved"
        );
      }
      // ======== End of email free gift setup in createCart(); ==============

      // Free shipping calculation
      var total_price_int = cart.total_price / 100;
      var price_before_free_shipping = 0;
      // console.log(total_price_int);
      if (total_price_int < 69.99) {
        price_before_free_shipping = (69.99 - total_price_int).toFixed(2);
        $(".Slide_cart_announcment_message").text(
          "You’re $" + price_before_free_shipping + " away from FREE shipping!"
        );
        var multiplier = 0.03;
        var progress_bar_percentage =
          100 - multiplier * price_before_free_shipping * 100;
        progress_bar_percentage = Math.floor(progress_bar_percentage);
        // console.log(progress_bar_percentage, price_before_free_shipping);
        $(".Slide_cart_progress_bar_inner").css(
          "width",
          progress_bar_percentage + "%"
        );
      } else {
        $(".Slide_cart_announcment_message").text(
          "You’ve unlocked FREE shipping!"
        );
        $(".Slide_cart_progress_bar_inner").css("width", "100%");
      }

      console.log(cart);
      var total_price = (cart.total_price / 100).toFixed(2);
      var compare_price_total = 0;
      var sale_product_in_cart = 0;
      $(".Slide_cart_upsells_slider").slick("slickUnfilter");
      $(".Slide_cart_whole_upsell__js").addClass("NotInCart");

      for (var i = 0; i < cart.items.length; i++) {
        var quantity = cart.items[i].quantity;
        var price = ((cart.items[i].price * quantity) / 100).toFixed(2);
        var currency = "$";
        var compare_price = "";
        let sellingPlanName = '';

        // Check if selling plan exists
        if (cart.items[i].selling_plan_allocation) {
          sellingPlanName = cart.items[i].selling_plan_allocation.selling_plan.name;
        }

        // Product check for upsell popups
        if (
          cart.items[i].handle.indexOf("bio-pod-refill-30-off") != -1 ||
          cart.items[i].handle.indexOf("the-wand-30-pack-35-off") != -1
        ) {
          sale_product_in_cart++;
        }

        // Product check for upsells
        $(".Slide_cart_whole_upsell__js").each(function () {
          for (var i = 0; i < cart.items.length; i++) {
            var data_id = parseFloat($(this).attr("data-id"));
            console.log(data_id, cart.items[i].product_id, "Test");
            if (data_id == cart.items[i].product_id) {
              console.log(data_id, cart.items[i].product_id);
              $(this).removeClass("NotInCart");
              // console.log('in cart yet');
            }
          }
        });

        // Price check
        $(".All_product_selector__js").each(function () {
          if ($(this).attr("data-id") == cart.items[i].id) {
            // console.log($(this).attr('data-compare-price'));
            compare_price = $(this).attr("data-compare-price");
            // console.log(compare_price, $(this).attr('data-id'));
          } else {
            // compare_price = '0.00';
          }
        });
        compare_price_integer = compare_price * quantity;
        compare_price = ((compare_price * quantity) / 100).toFixed(2);
        console.log(compare_price, "compare price");
        var price_integer;
        if (compare_price != "0.00") {
          console.log(
            cart.items[i].original_price,
            cart.items[i].final_price,
            "price_line"
          );
          if (cart.items[i].final_price == cart.items[i].original_price) {
            if (isNaN(compare_price)) {
              var price_line =
                '<span class="Slide_cart_line_curr_price__js">' +
                currency +
                price +
                "</span>";
              var discount_off =
                100 - ((100 * price) / compare_price).toFixed(0);
              var discount = "";
            } else {
              var price_line =
                '<span class="Slide_cart_line_curr_price__js">' +
                currency +
                price +
                '</span><s class="Slide_cart_line_past_price__js">' +
                currency +
                compare_price +
                "</s>";
              var discount_off =
                100 - ((100 * price) / compare_price).toFixed(0);
              var discount =
                '<p class="Slide_cart_discount_tab">-' +
                discount_off +
                "% OFF</p>";
              price_integer = quantity * cart.items[i].final_price;
            }

            // console.log('this');
          } else if (cart.items[i].final_price < cart.items[i].original_price) {
            compare_price = (
              (quantity * cart.items[i].original_price) /
              100
            ).toFixed(2);
            compare_price_integer =
              (quantity * cart.items[i].original_price) / 100;
            price = ((quantity * cart.items[i].final_price) / 100).toFixed(2);
            var price_line =
              '<span class="Slide_cart_line_curr_price__js">' +
              currency +
              price +
              '</span><s class="Slide_cart_line_past_price__js">' +
              currency +
              compare_price +
              "</s>";
            var discount_off = 100 - ((100 * price) / compare_price).toFixed(0);
            var discount =
              '<p class="Slide_cart_discount_tab">-' +
              discount_off +
              "% OFF</p>";
            price_integer = quantity * cart.items[i].final_price;
          }
        } else {
          var discount = "";
          if (cart.items[i].final_price == cart.items[i].original_price) {
            var price_line =
              '<span class="Slide_cart_line_curr_price__js">' +
              currency +
              price +
              "</span>";
            var discount_off = 100 - ((100 * price) / compare_price).toFixed(0);
            var discount = '<p class="Slide_cart_discount_tab"></p>';
            // console.log('without discount code');
            price_integer = quantity * cart.items[i].final_price;
          } else if (cart.items[i].final_price < cart.items[i].original_price) {
            compare_price = (
              (quantity * cart.items[i].original_price) /
              100
            ).toFixed(2);
            compare_price_integer = quantity * cart.items[i].original_price;
            price = ((quantity * cart.items[i].final_price) / 100).toFixed(2);
            var price_line =
              '<span class="Slide_cart_line_curr_price__js">' +
              currency +
              price +
              '</span><s class="Slide_cart_line_past_price__js">' +
              currency +
              compare_price +
              "</s>";
            var discount_off = 100 - ((100 * price) / compare_price).toFixed(0);
            var discount =
              '<p class="Slide_cart_discount_tab">-' +
              discount_off +
              "% OFF</p>";
            price_integer = quantity * cart.items[i].final_price;
          }
        }
        if (compare_price_integer == 0) {
          compare_price_total += price_integer;
          // console.log( price_integer, 'price integer');
        } else {
          //  console.log(compare_price_total, 'compare price total before');
          compare_price_total += compare_price_integer;
          // console.log(compare_price_total,' ',compare_price_integer, 'compare price integer');
        }
        //  compare_price_total += compare_price_integer;
        //  console.log(compare_price_total, 'compare price total');

        // Variant Title check
        var variant_title = cart.items[i].variant_title;
        if (variant_title) {
        } else {
          variant_title = "";
        }

        // Bordering cart items
        if (i == 0) {
          var Border_top = " Top";
        } else {
          var Border_top = "";
        }
        if (
          cart.items[i].id == freeEmailGiftVariant ||
          cart.items[i].id == freeDecanterGiftId ||
          cart.items[i].id == freeGlasseGiftId
        ) {
          cart_item[i] =
            `
        <div class="Slide_cart_item_line` +
            Border_top +
            `">
          <div>
            <img class="Slide_cart_item_image" src="` +
            cart.items[i].image +
            `">
          </div>
          <div>
            <h1 class="Slide_cart_item_title">` +
            cart.items[i].product_title +
            `</h1>
            <p class="Slide_cart_item_variant">` +
            variant_title +
            `</p>
            ` +
            discount +
            `
            <h1 class="Slide_cart_price">` +
            price_line +
            `
            </h1>
          </div>
          <div>
            <div class="Slide_cart_gift_price_cell">
             <p class="Slide_cart_gift_quantity">` +
            quantity +
            `</p>
             <p class="Slide_cart_remove_item__js" data-id="` +
            cart.items[i].id +
            `">Remove</p>
             </div>
            </div>
        </div>
            `;
        } else {
          cart_item[i] = `
            <div class="Slide_cart_item_line${Border_top}">
              <div>
                <img class="Slide_cart_item_image" src="${cart.items[i].image}" alt="${cart.items[i].product_title}">
              </div>
              <div>
                <h1 class="Slide_cart_item_title">${cart.items[i].product_title}</h1>
                <p class="Slide_cart_item_variant">${variant_title}</p>
                ${sellingPlanName ? `<p class="Slide_cart_item_selling_plan">${sellingPlanName}</p>` : ''}
                ${discount}
                <h1 class="Slide_cart_price">${price_line}</h1>
              </div>
              <div>
                <div class="Slide_cart_quantity_container">
                  <div class="Slide_cart_quantity_min__Js" data-id="${cart.items[i].id}">-</div>
                  <div class="Slide_cart_quantity_value__Js">${quantity}</div>
                  <div class="Slide_cart_quantity_add__Js" data-id="${cart.items[i].id}">+</div>
                </div>
              </div>
            </div>
          `;
        }
      }

      // SLide cart upsells
      $(".Slide_cart_upsells_slider").slick("slickFilter", ".NotInCart");
      if ($(".Slide_cart_upsells_slider .slick-track").is(":empty")) {
        // console.log('Upsell in cart should be empty');
        $(".Slide_cart_upsells_container_outer").hide();
      } else {
        $(".Slide_cart_upsells_container_outer").show();
        $(".Slide_cart_upsells_slider").slick("refresh");
      }

      // Sale popup checking
      if (sale_product_in_cart == 0) {
        $(".Popup_not_visible__js").attr("data-checkout", 0);
      } else {
        $(".Popup_not_visible__js").attr("data-checkout", 1);
      }
      if (cart.item_count == 0) {
        $(".Slide_cart_empty_content").show();
        $(".Slide_cart_upsells_title").hide();
        $(".Slide_cart_upsells_slider").css("opacity", "0");
        $(".Slide_cart_icons").hide();
        $(".Slide_cart_content_products").html(cart_item);
        $(".Slide_cart_title")
          .find("span")
          .text("• " + cart.item_count + " items");
        $(".Slide_cart_progress_bar").hide();
        $(".Slide_cart_announcment_message").hide();
        $(".Slide_cart_summary").hide();
        $(".Slide_cart_checkout_button__js").hide();
        $(".Checkout_button_reserve_message").hide();
      } else {
        $(".Slide_cart_empty_content").hide();
        $(".Slide_cart_upsells_title").show();
        $(".Slide_cart_upsells_slider").css("opacity", "1");
        $(".Slide_cart_icons").show();
        $(".Slide_cart_content_products").html(cart_item);
        $(".Slide_cart_title")
          .find("span")
          .text("• " + cart.item_count + " items");
        var discount_in_dollars =
          parseFloat(compare_price_total / 100) - parseFloat(total_price);
        if (discount_in_dollars > 0) {
          discount_in_dollars = discount_in_dollars.toFixed(2);
          compare_price_total = (compare_price_total / 100).toFixed(2);
          $(".Slide_cart_total_price").html(
            '<span class="Slide_cart_total_current__js">' +
              currency +
              total_price +
              '</span><s class="Slide_cart_total_past__js">' +
              currency +
              compare_price_total +
              "</s>"
          );
          $(".Slide_cart_save_discount").html(currency + discount_in_dollars);
          $(".Slide_cart_summary_discount").show();
        } else {
          $(".Slide_cart_summary_discount").hide();
          compare_price_total = (compare_price_total / 100).toFixed(2);
          $(".Slide_cart_total_price").html(
            '<span class="Slide_cart_total_current__js">' +
              currency +
              total_price +
              "</span>"
          );
        }
        $(".Slide_cart_progress_bar").show();
        $(".Slide_cart_announcment_message").show();
        $(".Slide_cart_summary").show();
        $(".Slide_cart_checkout_button__js").show();
        $(".Checkout_button_reserve_message").show();
      }
    });
    $(".Slide_cart_item_line").removeClass("Loading");
    $(".Slide_cart_upsells_container").removeClass("Loading");
  }, 1000);
}

function createCart() {
  // freeGiftSale();
  buildCart();
}

// SLide Cart checkout
$(document).ready(function () {
  createCart();

  function buildCheckoutUrl() {
    // Build the Checkout URL
    var checkout_url = "https://checkout.rechargeapps.com/r/checkout?",
      url_params = ["myshopify_domain=" + Shopify.shop];
    url_params = url_params.concat(get_cart_token()).concat(get_ga_linker());
    return checkout_url + url_params.join("&");
  }
  function filterVisible(elems) {
    // Return visible elements
    return elems.filter(function (elem) {
      return !!(
        elem.offsetWidth ||
        elem.offsetHeight ||
        elem.getClientRects().length
      );
    });
  }
  function filterValues(elems) {
    // Return inputs with valid values
    return elems.filter(function (elem) {
      var is_active_checkbox =
          elem.getAttribute("type") === "radio" && elem.checked,
        is_active_radio =
          elem.getAttribute("type") === "checkbox" && elem.checked,
        is_input =
          elem.getAttribute("type") !== "checkbox" &&
          elem.getAttribute("type") !== "radio";
      return (
        !!elem.value && (is_input || is_active_checkbox || is_active_radio)
      );
    });
  }
  function getCartJSON() {
    // Fetch the latest cart data from the /cart.js endpoint
    return fetch("/cart.js")
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        return { cart: JSON.stringify(json) };
      })
      .catch(function (error) {
        console.error("Error retreiving cart: ", error);
        return { cart: {} };
      });
  }
  function getTermsAndConditions() {
    // Find and return concacted terms and conditions values
    var condition_selectors = ["#terms", "#agree"],
      conditions = document.querySelectorAll(condition_selectors.join(",")),
      conditions_to_update = Array.prototype.slice.apply(conditions),
      conditions_filtered = filterValues(conditions_to_update),
      condition_values = conditions_filtered.map(function (elem) {
        return elem.value;
      });
    if (!condition_values.length) {
      return {};
    }
    return {
      terms_and_conditions: condition_values.join(", "),
    };
  }
  function getNotes() {
    // Find and return concatenated note values if visible
    var note_selectors = ['[name="note"]'],
      notes = document.querySelectorAll(note_selectors.join(",")),
      notes_to_update = Array.prototype.slice.apply(notes),
      notes_filtered = filterVisible(notes_to_update),
      note_values = notes_filtered.map(function (elem) {
        return elem.value;
      });
    var urlParams = new URLSearchParams(
        decodeURIComponent(window.location.search)
      ),
      noteFromUrl = urlParams.get("note");
    if (noteFromUrl) {
      note_values.push(noteFromUrl);
    }
    if (!note_values.length) return "";
    var uniqueNoteValues = note_values.filter(function (element, index, array) {
      return array.indexOf(element) === index;
    });
    return { note: uniqueNoteValues.join(", ") };
  }
  function getUTMAttributes() {
    // Retrieve UTMAttributes from Shopify cookie
    var shopifyCookieRegEx = /^_shopify_sa_p/;
    var utmRegEx = /^utm_/;
    var timestampRegEx = /^_shopify_sa_t/;
    var utmParams = {};
    var shopifyCookie = "";
    var timestamp = "";
    document.cookie
      .split(";")
      .map(function (s) {
        return s.trim();
      })
      .forEach(function (s) {
        if (shopifyCookieRegEx.test(s)) {
          shopifyCookie = s;
        }
        if (timestampRegEx.test(s)) {
          timestamp = decodeURIComponent(s.split("=")[1]);
        }
        return;
      });
    var utmValuesFromCookie = shopifyCookie.split("=")[1];
    decodeURIComponent(utmValuesFromCookie)
      .split("&")
      .forEach(function (s) {
        var key = s.split("=")[0];
        var val = s.split("=")[1];
        if (utmRegEx.test(key)) {
          return (utmParams[key] = val);
        }
        return;
      });
    if (!Object.keys(utmParams).length) {
      return undefined;
    }
    utmParams.utm_timestamp = timestamp;
    utmParams.utm_data_source = "shopify_cookie";
    return utmParams;
  }
  function getAttributes() {
    // Find and return cart attributes
    var attributeRegEx = /attributes\[(.*?)\]/,
      attributeNameRegex = /\[(.*?)\]/,
      attribute_selectors = ['[name*="attributes"]'],
      attributes = document.querySelectorAll(attribute_selectors.join(",")),
      attributes_to_update = Array.prototype.slice.apply(attributes),
      attributes_filtered = filterValues(attributes_to_update);
    var attribute_data = {},
      utm_attributes = getUTMAttributes(),
      attributes_from_url = new URLSearchParams(
        decodeURIComponent(window.location.search)
      );
    for (let pair of attributes_from_url) {
      if (attributeRegEx.test(pair[0])) {
        var attributeName = pair[0].match(attributeNameRegex)[0];
        attributeName = attributeName.substring(1, attributeName.length - 1);
        attribute_data[attributeName] = attributes_from_url.get(pair[0]);
      }
    }
    attributes_filtered.forEach(function (attribute) {
      var name = attribute.getAttribute("name"),
        value = attribute.value;
      if (attributeRegEx.test(name)) {
        var extractedName = name.match(attributeNameRegex)[0];
        extractedName = extractedName.substring(1, extractedName.length - 1);
        return (attribute_data[extractedName] = value);
      }
      return (attribute_data[name] = value);
    });
    if (utm_attributes) {
      Object.keys(utm_attributes).forEach(function (key) {
        attribute_data[key] = utm_attributes[key];
      });
    }
    if (!Object.keys(attribute_data).length) return {};
    return { attributes: Object.assign({}, attribute_data) };
  }
  function getCartData() {
    // Return cart attributes and data
    return getCartJSON().then(function (cartDataJSON) {
      var cart_data = {},
        termsAndConditions = getTermsAndConditions(),
        notes = getNotes(),
        attributes = getAttributes(),
        cart_data = cartDataJSON;
      [termsAndConditions, notes, attributes, cart_data].forEach(function (
        obj
      ) {
        Object.assign(cart_data, obj);
      });
      return cart_data;
    });
  }
  function get_cart_token() {
    // Build the cart_token param for the URL generator
    try {
      return [
        "cart_token=" + (document.cookie.match("(^|; )cart=([^;]*)") || 0)[2],
      ];
    } catch (e) {
      return [];
    }
  }
  function get_ga_linker() {
    // Build the ga_linker param for the URL generator
    try {
      return [ga.getAll()[0].get("linkerParam")];
    } catch (e) {
      return [];
    }
  }
  function buildInputs(form, obj) {
    // Build input fields for key, value pairs
    Object.keys(obj).forEach(function (key) {
      var input = document.createElement("input");
      input.setAttribute("type", "hidden");
      input.setAttribute("name", key);
      input.setAttribute(
        "value",
        typeof obj[key] === "object" ? JSON.stringify(obj[key]) : obj[key]
      );
      form.appendChild(input);
    });
  }
  function buildForm(data, url) {
    // Build a virtual form
    var form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", url);
    form.setAttribute("id", "rc_form");
    form.style.display = "none";
    buildInputs(form, data);
    return form;
  }
  function hasSubscription(data) {
    // Check if subscription items are found in cart data
    const cart = JSON.parse(data.cart);
    return [...cart.items].some(
      (item) => item.properties && item.properties.shipping_interval_unit_type
    );
  }
  function RechargeCartSubmit() {
    // Build and submit cart
    return getCartData().then(function (cart_data) {
      if (!hasSubscription(cart_data)) {
        // Send user to Shopify's checkout if no subscription products are found
        window.location.href = "/cart/checkout";
      } else {
        var checkout_url = buildCheckoutUrl();
        if (!cart_data) {
          // Cart data not found, fallback to token method
          window.location.href = checkout_url;
          return;
        }
        var xhr = new XMLHttpRequest();
        xhr.open("POST", "/cart/update.js");
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.onload = function () {
          if (xhr.status === 200) {
            window.console.log("done", JSON.parse(xhr.responseText));
          } else if (xhr.status !== 200) {
            window.console.log("fail", JSON.parse(xhr.responseText));
          }
          var form = buildForm(cart_data, checkout_url);
          document.body.appendChild(form);
          form.submit();
        };
        xhr.send(JSON.stringify(cart_data));
      }
    });
  }

  $(".Slide_cart_upsell_atc").click(function () {
    $(this)
      .parent("div")
      .parent(".Slide_cart_upsells_container")
      .addClass("Loading");
    var currentId = $(this).attr("data-id");
    var currentQuantity = 1;

    var atcButton = $(this);
    var atcText = atcButton.text();
    atcButton.text("Adding...");

    data = {
      id: currentId,
      quantity: currentQuantity,
    };
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        console.log(data);
        createCart();
        setTimeout(() => {
          atcButton.text(atcText);
        }, 500);
      },
    });
  });

  $(".Slide_cart_upsell_variant_select").change(function () {
    var currentId = $(this).val();
    // console.log(currentId);
    $(this)
      .parent("div")
      .parent(".Slide_cart_upsells_container")
      .find(".Slide_cart_upsell_atc")
      .attr("data-id", currentId);
    $(".Slide_cart_upsell_image_js").hide();
    $(".Slide_cart_upsell_price").hide();
    $(".Slide_cart_upsell_image_js").each(function () {
      if ($(this).attr("data-id") == currentId) {
        $(this).show();
      }
      $(".Slide_cart_upsell_price").each(function () {
        if ($(this).attr("data-id") == currentId) {
          $(this).show();
        }
      });
    });
  });

  $(".Slide_cart_checkout_button__js").click(function (evt) {
    jQuery.getJSON("/cart.js", function (cart) {
      console.log(cart);
      var party_in_cart = 0;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].handle.indexOf("the-pink-wand-bachelorette") != -1) {
          party_in_cart++;
        }
      }
      if (party_in_cart == 0){
        if ($(this).hasClass("Disabled")) {
          evt.preventDefault();
          setTimeout(function () {
            $(".Slide_cart_checkout_button__js").removeClass("btn--loading");
          }, 500);
        } else {
          // Initiating upsell popups
          evt.preventDefault();
          var statement = $(".Popup_not_visible__js").attr("data-checkout");
          console.log(statement);
          if (statement == "0") {
            jQuery.getJSON("/cart.js", function (cart) {
              console.log(cart);
              var phoenix_in_cart = 0;
              var pod_in_cart = 0;
              for (var i = 0; i < cart.items.length; i++) {
                if (cart.items[i].handle.indexOf("phoenix-starter-kit") != -1) {
                  phoenix_in_cart++;
                }
                else if(cart.items[i].handle.indexOf("bio-pod-refill") != -1){
                  pod_in_cart++;
                }
              }
              if (phoenix_in_cart > 0) {
                phoenix_in_cart++;
                console.log("Phoenix in cart");
                $(".Whole_cart_popup.Pods_popup").css("display", "flex");
                setTimeout(function () {
                  $(".Whole_cart_popup.Pods_popup").css("opacity", "1");
                }, 200);
              }
              else if (pod_in_cart > 0) {
                pod_in_cart++;
                console.log("Pod in cart");
                $(".Whole_cart_popup.Pods_popup").css("display", "flex");
                setTimeout(function () {
                  $(".Whole_cart_popup.Pods_popup").css("opacity", "1");
                }, 200);
              }
              else {
                console.log("Something else in cart");
                $(".Whole_cart_popup.Wand_popup").css("display", "flex");
                setTimeout(function () {
                  $(".Whole_cart_popup.Wand_popup").css("opacity", "1");
                }, 200);
              }
            });
          } else {
            RechargeCartSubmit();
          }
        }
      }
      else{
        window.location.href = '/checkout';
      }
    });
    
  });

  $(".Cart_upsell_add_to_cart_btn").click(function () {
    var currentVariantId = $(this).attr("data-id");
    data = {
      id: currentVariantId,
      quantity: 1,
    };

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        // window.location = '/checkout';
        $(".Whole_cart_popup").css("opacity", "0");
        setTimeout(function () {
          $(".Whole_cart_popup").hide();
        }, 200);
        createCart();
        RechargeCartSubmit();
      },
    });
  });

  $(".Cart_upsell_decline_offer_message").click(function () {
    $(".Whole_cart_popup").css("opacity", "0");
    setTimeout(function () {
      $(".Whole_cart_popup").hide();
    }, 200);
    // window.location = '/checkout';
    RechargeCartSubmit();
  });

  $(document).on("click", ".Slide_cart_quantity_min__Js", function () {
    var currentId = $(this).attr("data-id");
    var currentQuantity = $(this)
      .parent(".Slide_cart_quantity_container")
      .find(".Slide_cart_quantity_value__Js")
      .text();
    currentQuantity = parseFloat(currentQuantity);
    currentQuantity--;

    $(this)
      .parent(".Slide_cart_quantity_container")
      .parent("div")
      .parent(".Slide_cart_item_line")
      .addClass("Loading");

    data = {
      id: currentId,
      quantity: currentQuantity,
    };
    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: data,
      dataType: "json",
      success: function () {
        console.log(data);
        createCart();
      },
    });
  });
  $(document).on("click", ".Slide_cart_remove_item__js", function () {
    var currentId = $(this).attr("data-id");
    data = {
      id: currentId,
      quantity: 0,
    };
    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: data,
      dataType: "json",
      success: function () {
        console.log(data);
        createCart();
      },
    });
  });

  $(document).on("click", ".Slide_cart_quantity_add__Js", function () {
    var currentId = $(this).attr("data-id");
    var currentQuantity = $(this)
      .parent(".Slide_cart_quantity_container")
      .find(".Slide_cart_quantity_value__Js")
      .text();
    currentQuantity = parseFloat(currentQuantity);
    currentQuantity++;

    $(this)
      .parent(".Slide_cart_quantity_container")
      .parent("div")
      .parent(".Slide_cart_item_line")
      .addClass("Loading");

    data = {
      id: currentId,
      quantity: currentQuantity,
    };
    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: data,
      dataType: "json",
      success: function () {
        console.log(data);
        createCart();
      },
    });
  });

  $(".Slide_cart_close_button").click(function () {
    $(".Slide_cart_whole").css("right", "-600px");
    $(".Slide_cart_overlay").hide();
  });

  $(".Slide_cart_overlay").click(function () {
    $(".Slide_cart_whole").css("right", "-600px");
    $(".Slide_cart_overlay").hide();
  });

  $(".js-drawer-open-cart").click(function (evt) {
    evt.preventDefault();
    $(".Slide_cart_whole").css("right", "0px");
    $(".Slide_cart_overlay").show();
  });

  // Subscribtion selector
  $(".Subscribtion_widget_selector__js").click(function () {
    // $('.js-qty__num').val(1);
    var value = $(this).attr("data");
    var product = $(this).attr("data-product");
    $(".Subscribtion_widget_selector__js").removeClass("active");
    $(this).addClass("active");
    // console.log(value);
    // console.log(product);

    if (value == "autodeliver") {
      $(".Subscribtion_frequency_selector").show();
      $(".product-single__variants").attr("data-mode", "autodeliver");
      if (product.indexOf("The Wand") != -1) {
        // Setting the environment

        $(".wand-selector .wrapper_1 .input_num_3").addClass("hidden_for_subs");
        $(".wand-selector .wrapper_1 .input_num_2").addClass("hidden_for_subs");
        $(".wand-selector .wrapper_1 .input_num_4").addClass("hidden_for_subs");

     //   $(".wand-selector .wrapper_2 .input_num_2").addClass("hidden_for_subs");
        $(".wand-selector .wrapper_2 .input_num_3").addClass("hidden_for_subs");
        $(".wand-selector .wrapper_2 .input_num_4").addClass("hidden_for_subs");
        $(".wand-selector .wrapper_2 .input_num_5").addClass("hidden_for_subs");
        $(".wand-selector .wrapper_2 .input_num_6").addClass("hidden_for_subs");
        $(".wand-selector .wrapper_1 .input_num_1 input").trigger("click");
        $(".wand-selector .wrapper_2 .input_num_1 input").trigger("click");
        // console.log($('.product-single__variants').val(), 'val');
        $(".product-single__variants").attr("subscribe_id", 43619458973939);
      }
      if (product.indexOf("Pod") != -1) {
        // var currentPrice = 39.99;
        // var comparePrice = parseFloat($('.visible_product_price').attr('original_compare_price')) / 100;
        // if (comparePrice) {

        // }
        // else {
        //   var comparePrice = parseFloat($('.visible_product_price').attr('original_price')) / 100;
        //   $('.visible_product_price').attr('original_compare_price', comparePrice * 100);
        //   $('.visible_product_price').attr('original_price', currentPrice * 100);
        // }
        // $(".product-single__variants").attr('subscribe_id', 43619474931955);
        // var discount = (comparePrice - currentPrice).toFixed(2);
        // var discount_percent = (100 - (100 * currentPrice / comparePrice)).toFixed(0);
        // // console.log(discount, comparePrice, currentPrice);
        // // console.log('price should be changed to', currentPrice, comparePrice);
        // $('.visible_product_price.Product_current_price').text('$ ' + currentPrice);
        // $('.product_compare_at_price').text('$ ' + comparePrice);
        // $('.Product_price_sale_tag').show();
        // $('.Product_price_discount').show();
        // $('.Product_price_discount').find('span').text('$' + discount);
        // $('.Product_price_sale_tag').text('-' + discount_percent + '% OFF');
        // $(".wand-selector .wrapper_1 .input_num_2").addClass('hidden_for_subs');
        $(".wand-selector .wrapper_1 .input_num_1 input").trigger("click");
        $(".product-single__variants").attr("subscribe_id", 43619474931955);
      }
      if (product.indexOf("Wave") != -1) {
        $(".wrapper_1 .input_num_2 input").trigger("click");
        $(".wand-selector .wrapper_1 .input_num_1").addClass("hidden_for_subs");
      }
    } else {
      setTimeout(function () {
        var url = window.location.href;
        var variant_id = url.substr(url.length - 14);
      }, 100);
      $(".Subscribtion_frequency_selector").hide();
      // Setting the environment
      $(".variant-input ").removeClass("hidden_for_subs");
      $(".wand-selector .wrapper_1 .input_num_1 input").trigger("click");
      $(".wand-selector .wrapper_2 .input_num_1 input").trigger("click");
      $(".product-single__variants").attr("data-mode", "onetime");
      // if (product.indexOf('Pod') != -1) {
      //   var currentPrice = parseFloat($('.visible_product_price').attr('original_price_notchangable')) / 100;
      //   // console.log('price should be changed to', currentPrice);
      //   $('.visible_product_price.Product_current_price').text('$ ' + currentPrice);
      //   var comparePrice = parseFloat($('.visible_product_price').attr('original_compare_price_notchangable')) / 100;
      //   $('.visible_product_price').attr('original_compare_price', comparePrice * 100);
      //   $('.visible_product_price').attr('original_price', currentPrice * 100);
      //   if (comparePrice) {
      //     $('.product_compare_at_price').text('$ ' + comparePrice);
      //   }
      //   else {
      //     $('.product_compare_at_price').text('');
      //     $('.Product_price_sale_tag').hide();
      //     $('.Product_price_discount').hide();
      //   }
      // }
    }
  });

  $(".product-single__form").submit(function (evt) {

    var modePrime = $('.add-to-cart').attr('data-prime');

    evt.preventDefault();
    var currentQty = $(".js-qty__num").val();
    var selectedMode = $(".product-single__variants").attr("data-mode");
    if (selectedMode == "autodeliver") {
      var currentId = $(".product-single__variants").attr("subscribe_id");
      var unit_type = "Days";
      var frequency = $(".Subscribtion_frequency_select__js")
        .val()
        .replace(" Days", "");
      var plan_x = 0;
      if(frequency == 60){
        plan_x = 1;
      } else if (frequency == 90){
        plan_x = 2;
      }
      var pwproSlug = $(".product-single__variants").attr("pw_product_slug");
      var sellingPlanId;
      // Step 1: Fetch Product Details with Selling Plans
      fetch(`/products/${pwproSlug}.js`)
        .then(response => response.json())
        .then(product => {
          console.log(product.selling_plan_groups[0].selling_plans[0].name);
          // Find the selling plans for the given variant ID
          const variant = currentId;
          if (product && product.selling_plan_groups) {
            sellingPlanId = product.selling_plan_groups[0].selling_plans[plan_x].id; // Choose the desired selling plan ID
            console.log('selling plan id: '+sellingPlanId);
            console.log('currentId: '+currentId);
            // Add to cart now that sellingPlanId is available
            var data = {
              id: currentId,
              quantity: currentQty,
              selling_plan: sellingPlanId,
              //properties: {
                //shipping_interval_frequency: frequency,
                //shipping_interval_unit_type: unit_type,
              //},
            };
            console.log(data);
            addToCart(data);
          } else {
            console.error('No selling plans found for this variant.');
          }
        })
        .catch(error => console.error('Error fetching product details:', error));
      
      //data = {
        //id: currentId,
        //quantity: currentQty,
        //selling_plan: sellingPlanId,
        //properties: {
          //shipping_interval_frequency: frequency,
          //shipping_interval_unit_type: unit_type,
        //},
      //};
    } else {
      var currentId = $(".product-single__variants").val();
      data = {
        id: currentId,
        quantity: currentQty,
      };
      console.log(data);
      addToCart(data);
    }
    var atcButton = $(this).find(".add-to-cart>span");
    var atcText = atcButton.text();
    if (modePrime != 'true')
    {
      atcButton.text("Adding...");
      console.log("ATC TEXT: " + atcText);
    }
    

    

    function addToCart(data) {
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          console.log(data);
          createCart();
        },
      });
    }
    
    setTimeout(function () {
      $(".Slide_cart_whole").css("right", "0px");
      $(".Slide_cart_overlay").show();
      if (modePrime != 'true')
      {
        atcButton.text(atcText);
      }
    }, 1600);
  });
});

// Sticky atc

$(window).on("scroll", function () {
  var scrolled = $(document).scrollTop();
  // console.log(scrolled);
  if ($(window).width() < 960) {
    if (scrolled > 1300) {
      $(".Sticky_atc_button").addClass("visible");
    } else {
      $(".Sticky_atc_button").removeClass("visible");
    }
  } else {
    if (scrolled > 800) {
      $(".Sticky_atc_button").addClass("visible");
    } else {
      $(".Sticky_atc_button").removeClass("visible");
    }
  }
});

$(".Sticky_atc_selector").change(function () {
  var variant_title = [];
  var i = 0;
  if ($(this).hasClass("Quantity")) {
    $(".Sticky_atc_selector").each(function () {
      var value = $(this).val();
      // console.log(value);
      if (value.indexOf("8 Pack") != -1) {
        $(".Color")
          .find(".Sticky_atc_option__js")
          .each(function () {
            if (
              $(this).attr("value") == "Silver" ||
              $(this).attr("value") == "Pink" ||
              $(this).attr("value") == "Red" ||
              $(this).attr("value") == "Silver & Gold"
            ) {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
        $(".Sticky_atc_selector.Color").val("Silver");
      } else if (value.indexOf("3 Pack") != -1) {
        $(".Color")
          .find(".Sticky_atc_option__js")
          .each(function () {
            if ($(this).attr("value") == "Silver") {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
        $(".Sticky_atc_selector.Color").val("Silver");
      } else if (value.indexOf("30 Pack") != -1) {
        $(".Color")
          .find(".Sticky_atc_option__js")
          .each(function () {
            if (
              $(this).attr("value") == "Silver" ||
              $(this).attr("value") == "USA"
            ) {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
        $(".Sticky_atc_selector.Color").val("Silver");
      } else if (value.indexOf("40 Pack") != -1) {
        $(".Color")
          .find(".Sticky_atc_option__js")
          .each(function () {
            if ($(this).attr("value") == "Variety") {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
        $(".Sticky_atc_selector.Color").val("Variety");
      } else if (value.indexOf("90 Pack") != -1) {
        $(".Color")
          .find(".Sticky_atc_option__js")
          .each(function () {
            if ($(this).attr("value") == "Silver") {
              $(this).show();
            } else {
              $(this).hide();
            }
          });
        $(".Sticky_atc_selector.Color").val("Silver");
      }
      variant_title[i] = value;
      i++;
    });
  } else {
    $(".Sticky_atc_selector").each(function () {
      var value = $(this).val();
      variant_title[i] = value;
      i++;
    });
  }

  var currentVariantTitle = variant_title[0] + " / " + variant_title[1];
  // console.log(currentVariantTitle);

  // Selecting current Id
  var currentId = 0;
  var currentInvQty = 0;
  $(".Sticky_atc_button_variant_selector__js").each(function () {
    if ($(this).attr("data-title") == currentVariantTitle) {
      currentId = $(this).attr("data-id");
      currentInvQty = $(this).attr("data-inventory");
    }
  });

  // Price select
  $(".Sticky_atc_pricing_element_js").hide();
  $(".Sticky_atc_pricing_element_js").each(function () {
    if ($(this).attr("data") == currentId) {
      $(this).show();
    }
  });

  // console.log(currentId);
  if (currentId != "43588373643507") {
    if (currentInvQty > 0) {
      $(".Sticky_atc_btn").text("ADD TO CART");
    } else {
      $(".Sticky_atc_btn").text("SOLD OUT");
    }
  }
  $(".Sticky_atc_btn").attr("data-id", currentId);
});

$(".Sticky_atc_variant_selector_btn__js").click(function () {
  $(".Sticky_atc_variant_selector_btn__js").removeClass("active");
  $(this).addClass("active");
  var variantId = $(this).attr("data-id");

  // Price select
  $(".Sticky_atc_pricing_element_js").hide();
  $(".Sticky_atc_pricing_element_js").each(function () {
    if ($(this).attr("data") == variantId) {
      $(this).show();
    }
  });
  // var currentInvQty = $(this).attr('data-inventory');
  // if (currentInvQty > 0){
  //   $('.Sticky_atc_btn').text('ADD TO CART');
  // }
  // else{
  //   $('.Sticky_atc_btn').text('SOLDOUT');
  // }
  $(".Sticky_atc_btn").attr("data-id", variantId);
});

$(".Sticky_atc_btn").click(function () {
  var currentVariant = $(this).attr("data-id");
  var currentTitle = $(this).attr("product-title");

  var atcButton = $(this);
  var atcText = atcButton.text();
  atcButton.text("Adding...");

  data = {
    id: currentVariant,
    quantity: 1,
  };

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      console.log(data);
      createCart();
      setTimeout(function () {
        $(".Slide_cart_whole").css("right", "0px");
        $(".Slide_cart_overlay").show();
        gtag("event", "click", {
          event_category: "Added To Cart",
          event_label: "Added To Cart : " + currentTitle + " (with Sticky ATC)",
        });
        // console.log('Added To Cart : ' + currentTitle + ' (with Sticky ATC)');
        atcButton.text(atcText);
      }, 500);
    },
  });
});

// Long Form
$(document).ready(function () {
  // Long Form Sticky Button
  if ($(".sticky-atc__atc")) {
    $(".sticky-atc__atc").click((e) => {
      e.preventDefault();
      var currentScrollPosition = $(window).scrollTop();

      var closestSection = null;
      var closestDistance = Infinity;
      $(".long-form-featured").each(function () {
        var distance = Math.abs($(this).offset().top - currentScrollPosition);
        if (distance < closestDistance) {
          closestSection = this;
          closestDistance = distance;
        }
      });

      if (closestSection) {
        $("html,body").animate(
          {
            scrollTop: $(closestSection).offset().top,
          },
          "slow"
        );
      }
    });
  }

  // Long Form Reviews Slick
  $(".long-form-reviews__container").slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          dots: true,
          arrows: false,
        },
      },
    ],
  });

  handleSlick();
  $(window).resize(function () {
    handleSlick();
  });
});

function handleSlick() {
  if ($(window).width() >= 800) {
    $(".long-form-featured__container").slick("unslick");
  } else {
    $(".long-form-featured__container").slick({
      dots: true,
      arrows: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: "30px",
    });
  }
}

// Advertorial Landing
$(document).ready(function () {
  if ($("#phoenix-atc")) {
    const productID = "43433556410611";

    $(".getnow-cta-btn, .informative-offer-card__cta").click(function (e) {
      e.preventDefault();
      var atcButton = $(this);
      var atcText = atcButton.text();
      atcButton.text("Adding...");

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: 1,
          id: productID,
        },
        dataType: "json",
        success: function () {
          window.location.href = "/checkout";
        },
        error: function () {
          // console.log('Error adding product to cart.');
        },
      });
    });
  }
});

// Why Purewine Landing
$(".product-offer__btn").click(function (e) {
  $(this).find("p").text("Adding...");
});

// Wine Purifier Landing
$(".Offer_product_atc_button").click(function (e) {
  $(this).text("Adding...");
});

$(document).ready(function () {
  const timerElements = $(".productOfferTimer");

  const countdownDuration = 15 * 60;

  // Get the current time (in milliseconds)
  const currentTime = new Date().getTime();

  // Calculate the end time of the countdown (in milliseconds)
  const endTime = currentTime + countdownDuration * 1000;

  // Update the timer every second
  const timerInterval = setInterval(() => {
    // Get the current time (in milliseconds)
    const currentTime = new Date().getTime();

    // Calculate the remaining time (in seconds)
    const remainingTime = Math.floor((endTime - currentTime) / 1000);

    // If the countdown has ended, clear the interval
    if (remainingTime <= 0) {
      clearInterval(timerInterval);
      return;
    }

    // Format the remaining time as 'MM:SS'
    const minutes = Math.floor(remainingTime / 60)
      .toString()
      .padStart(2, "0");
    const seconds = (remainingTime % 60).toString().padStart(2, "0");
    const timeString = `${minutes}:${seconds}`;

    // Update each timer element with the remaining time
    timerElements.text(timeString);
  }, 1000);

  // Reset the timer when the page is refreshed
  $(window).on("beforeunload", function () {
    clearInterval(timerInterval);
  });

  $(document).on("click", ".slick-arrow", function () {
    // alert();
    var video = $("video");
    video.get(0).play();
  });

  // Get all video elements and play buttons
  var videos = $(
    ".Homepage_flex_section__media video, .video-flex__media video"
  );
  var playButtons = $(
    ".Homepage_flex_section__media-play, .video-flex__media-play"
  );

  // Iterate over each video
  videos.each(function (index) {
    var videoElement = this;
    var playButton = playButtons.eq(index);

    playButton.click(function () {
      videoElement.play();
      $(this).hide();
    });

    $(videoElement).click(function () {
      if (!videoElement.paused) {
        videoElement.pause();
        playButton.show();
      }
    });
  });

  var scrollButtons = $(
    ".Homepage_banner_scroll_button:not(a .Homepage_banner_scroll_button):not(.Featured_collection_product_card_atc_button)"
  );
  var scrollTo = $(".Homepage_featured_collection");

  scrollButtons.click(function () {
    $("html, body").animate(
      {
        scrollTop: scrollTo.offset().top,
      },
      400
    );
  });

  $(".tiktok_judgeme_imitation span").click(function () {
    $("html, body").animate(
      {
        scrollTop: $(".Test_results_outer").offset().top,
      },
      400
    );
  });



  if (window.location.href.indexOf("/products/the-wand-1?variant=41883690008763") !== -1) {
    setTimeout(function () {
      $(".Autodelivery_trigger__js").trigger("click");
    }, 500);
  }


  if (window.location.href.indexOf("/products/bio-pod-refill?variant=43766804676851") !== -1) {
    setTimeout(function () {
      $(".Autodelivery_trigger__js").trigger("click");
    }, 500);
  }
  

  $('.site-nav__shop_dropdown').mouseover(function(){
    $('.hdp_out').slideDown();
  });

  $('.site-nav_trigger_up').mouseover(function(){
    $('.hdp_out').slideUp();
  });

  $('.site-header').mouseleave(function(){
    $('.hdp_out').slideUp();
  });
});
 
